module.exports = __webpack_public_path__ + "static/media/Danielle Harpaz.d3b3a54a.png";